import type { App, AppsResponse, Story } from '@/types'
import { isArray } from '@/utils/checkers/validation'
import { isEmpty } from './checkers'

export type BlockContentPreviewImage = {
  alt: string
  copyright: string
  focus: string
  filename: string
  id: number
  is_external_url: boolean
  name: string
  title: string
}

type CDNStoryAppResponse = Story & {
  content: {
    component: 'external_app'
    logo: BlockContentPreviewImage
    preview_image: BlockContentPreviewImage
    short_description: string
    author_name: string
    app_link: string
    last_update: string
    long_description: string
  }
}

export const sanitizeStoriesToApps = (
  stories: CDNStoryAppResponse[],
): AppsResponse | Array<unknown> => {
  if (isEmpty(stories)) {
    return []
  }

  return stories.map((story: CDNStoryAppResponse) => {
    return {
      name: story.name,
      icon: story.content?.logo?.filename,
      intro: story.content?.short_description,
      id: story.id,
    }
  })
}

export const sanitizeStoryToApp = (
  story: CDNStoryAppResponse,
): App | unknown => {
  if (isEmpty(story)) {
    return {}
  }

  const content = story.content

  const screenshot = isArray(content?.preview_image)
    ? content?.preview_image
    : content?.preview_image?.filename

  return {
    name: story.name,
    slug: story.slug,
    id: story.id,
    icon: content?.logo.filename,
    intro: content?.short_description,
    author: content?.author_name,
    website: content?.app_link,
    updated_at: content?.last_update,
    description: content?.long_description,
    screenshot,
  }
}
